'use client';

import React from 'react';
import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { LocaleProvider } from '@/contexts/LocaleContext';
import { useLocaleFromPath } from '@/hooks/useLocaleFromPath';

/**
 * Wraps error/not-found content with Header and Footer.
 * Used when those pages render outside [lang] layout (no LocaleProvider).
 */
export function ErrorPageShell({ children }: { children: React.ReactNode }) {
  const locale = useLocaleFromPath();
  return (
    <LocaleProvider locale={locale}>
      <Header />
      <main>{children}</main>
      <Footer />
    </LocaleProvider>
  );
}
